import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";
import { showNotification } from "../../../../Common/Toast/Toast";

const initialState = {
  errors: null,
  isLoading: false,
  getProfileData: [],
  profileDataUpdate: [],
  getprofileWithWork:[]

};

const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setGetProfileData: (state, action) => {
      state.getProfileData = action.payload;
    },
       setProfileWithWork: (state, action) =>{
      state.getprofileWithWork = action.payload;
    }
  },
});

export const getProfileData = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "/profile";
    const response = await axiosInstance.get(URL);
    const { status, message, data} = response?.data || {};

    if (status === "success") {
      dispatch(setGetProfileData(data));
    } 
 } catch (error) {
  const errorResponse = error?.response;
  
  dispatch(setErrors({
    status: errorResponse?.status,
    statusText: errorResponse?.statusText,
    message: errorResponse?.data?.message || error.message || "Something went wrong."
  }));

}
}

export const GetProfilewithWorks =(workerId) => async(dispatch)=>{
  dispatch(setLoading(true));
  try{
    let URL = `/worker/${workerId}`;
    const response =await axiosInstance.get(URL);
    const {status,message,data} = response?.data || {};

    if(status === "success"){
      dispatch(setProfileWithWork(data));
    }

  }catch(error){
     const errorResponse = error?.response;
  
  dispatch(setErrors({
    status: errorResponse?.status,
    statusText: errorResponse?.statusText,
    message: errorResponse?.data?.message || error.message || "Something went wrong."
  }));

  }
}



export const updateProfileData = (updatedData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "/profile";
    const response = await axiosInstance.put(URL,updatedData)
    const { status, message } = response?.data || {};

    if (status === "success") {
      dispatch(setGetProfileData(response?.data?.data));
      showNotification({
        message: message || "Profile updated successfully",
        theme: "light",
        type: "success", 
      });
    } else {
      showNotification({
        message: message || "Something went wrong",
        theme: "light",
        type: "error", 
      });
    }
  } catch (error) {
    dispatch(setErrors(error?.response));
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";
    showNotification({
      message: errorMsg,
      theme: "light",
      type: "error", 
    });
  }
  dispatch(setLoading(false));
};



export const { setErrors, setLoading, setGetProfileData,setProfileWithWork } = ProfileSlice.actions;

export default ProfileSlice.reducer;
